import { Icon } from './Icon';

export interface PaneEmptyProps {
  icon?: string; // Icon name (default 'search')
  title: string;
  hint?: string;
}

// The shared empty state for a master-detail pane — a centered icon + title +
// hint, used whenever nothing is selected yet (new booking with no owner, new
// leave with no helper, no person picked). One component so every modal's empty
// pane reads identically instead of a stray left-aligned line of text.
export function PaneEmpty({ icon = 'search', title, hint }: PaneEmptyProps) {
  return (
    <div className="pane anim-fade pane-empty">
      <div className="pane-empty-card">
        <div className="pane-empty-icon"><Icon name={icon} size={22} /></div>
        <div className="pane-empty-title">{title}</div>
        {hint && <div className="pane-empty-hint">{hint}</div>}
      </div>
    </div>
  );
}
